/**
 * The copy system. Every user-visible string lives in a copy file, so Greek can be added later
 * without touching screens. Shell strings live next to this file (one file per area). A module
 * keeps its own strings in client/src/modules/<name>/copy.ts and calls `defineCopy` there.
 *
 * Voice (BRAND.md): funny, loud, friendly. Short lines, second person, rib the player and never
 * the person. No em dashes. One joke per string at most. Errors say what happened and what to do.
 *
 *   export const copy = defineCopy('games', { undo: 'Bucket removed. The ref has spoken.' });
 *   fill('Sub: {in} in for {out}', { in: 'Kostas', out: 'Alex' })
 */

export type CopyValue = string | readonly string[] | CopyTree;
export type CopyTree = { readonly [key: string]: CopyValue };

const registry = new Map<string, CopyTree>();

export function defineCopy<const T extends CopyTree>(scope: string, strings: T): T {
  registry.set(scope, strings);
  return strings;
}

/** Every copy tree defined so far (the copy lint test walks these). */
export function allCopy(): ReadonlyMap<string, CopyTree> {
  return registry;
}

/** Replace {name} placeholders. Unknown placeholders stay visible so they get noticed. */
export function fill(template: string, vars: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (m, k: string) => (k in vars ? String(vars[k]) : m));
}

/** "1 play" / "3 plays". English only for now; Greek gets its own rule later. */
export function plural(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}
